// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"706":"3830779d3b2dcad9","1016":"25c21b733ac92657","3204":"e9fefbfc274a68fb","3760":"ef831d01791be4b3","9464":"063f24a0d2966ed4"}[chunkId] + ".css";
};